import { FieldPath, FieldValues } from "react-hook-form";
import { TextFieldProps } from "@mui/material";
import { RhfInputProps } from "../../Forms/RhfInputProps";
import { MdmFormProps } from "../../Forms/MdmFormProps";
import { isElementInArray } from "../../Utils/arrays";
import { GeoCoordinates } from "../../Locations/GeoCoordinates";
import { TextFieldInput } from "../../Forms/TextFieldInput";

type GeoCoordinatesAddressTextFieldProps = {
  triggerGeoCoordinatesCalculation: (fallbackGeoCoordinates: GeoCoordinates) => void;
};

export const GeoCoordinatesAddressTextField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  name,
  label,
  required,
  disabledFields,
  disabled,
  triggerGeoCoordinatesCalculation,
  ...otherProps
}: RhfInputProps<TFieldValues, TName> &
  MdmFormProps &
  TextFieldProps &
  GeoCoordinatesAddressTextFieldProps) => {
  return (
    <TextFieldInput
      {...otherProps}
      name={name}
      control={control}
      label={label || name}
      required={required}
      disabled={disabled || isElementInArray(disabledFields, name)}
      onChange={() => {
        triggerGeoCoordinatesCalculation({ latitude: "", longitude: "" });
      }}
    />
  );
};
